export function parseParcelMeasurementsState(value) {
    var mask = parseInt(value == null ? '' : String(value), 10);
    if (!isFinite(mask) || mask < 1 || mask > 3) mask = 0;

    return {
        visible: (mask & 1) !== 0,
        setbacksEnabled: (mask & 2) !== 0,
    };
}

export function encodeParcelMeasurementsState(state) {
    var mask = 0;
    if (state && state.visible) mask |= 1;
    if (state && state.setbacksEnabled) mask |= 2;
    return mask ? String(mask) : '';
}
